var map = {
	"./Digital/Home/Article1": 1,
	"./Digital/Home/Article1.js": 1,
	"./Digital/Home/articles": 917,
	"./Digital/Home/articles.json": 917,
	"./Digital/Home/cards/AFFICHE ARTICLE-7.jpg": 104,
	"./MiddleSchool/Grade6/Article1": 455,
	"./MiddleSchool/Grade6/Article1.js": 455,
	"./MiddleSchool/Grade6/articles": 587,
	"./MiddleSchool/Grade6/articles.json": 587,
	"./MiddleSchool/Grade6/cards/AFFICHE ARTICLE-9.jpg": 673,
	"./MiddleSchool/Grade6/cards/Article1.jpeg": 487,
	"./MiddleSchool/Grade6/cards/Article2.jpeg": 475,
	"./MiddleSchool/Grade7/Article1": 702,
	"./MiddleSchool/Grade7/Article1.js": 702,
	"./MiddleSchool/Grade7/articles": 55,
	"./MiddleSchool/Grade7/articles.json": 55,
	"./MiddleSchool/Grade7/cards/AFFICHE ARTICLE-10.jpg": 674,
	"./MiddleSchool/Grade7/cards/Article1.jpeg": 352,
	"./MiddleSchool/Grade7/cards/Article2.jpeg": 712,
	"./MiddleSchool/Grade8/Article1": 436,
	"./MiddleSchool/Grade8/Article1.js": 436,
	"./MiddleSchool/Grade8/articles": 209,
	"./MiddleSchool/Grade8/articles.json": 209,
	"./MiddleSchool/Grade8/cards/AFFICHE ARTICLE-11.jpg": 918,
	"./MiddleSchool/Grade8/cards/Article1.jpeg": 958,
	"./MiddleSchool/Grade8/cards/Article2.jpeg": 286,
	"./MiddleSchool/Home/Article2": 124,
	"./MiddleSchool/Home/Article2.js": 124,
	"./MiddleSchool/Home/articles": 130,
	"./MiddleSchool/Home/articles.json": 130,
	"./MiddleSchool/Home/cards/AFFICHE ARTICLE-12.jpg": 766,
	"./MiddleSchool/Home/cards/backtoschool_notebook.svg": 274,
	"./TeacherPaper/Home/Article1": 967,
	"./TeacherPaper/Home/Article1.js": 967,
	"./TeacherPaper/Home/Article2": 780,
	"./TeacherPaper/Home/Article2.js": 780,
	"./TeacherPaper/Home/articles": 509,
	"./TeacherPaper/Home/articles.json": 509,
	"./TeacherPaper/Home/cards/AFFICHE ARTICLE-8.jpg": 456,
	"./TeacherPaper/Home/cards/Article1.jpeg": 135,
	"./TeacherPaper/Home/cards/Article2.jpeg": 554
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 213;